"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getDefinables_1 = __importDefault(require("./getDefinables"));
const getDefinablesCount = (className) => (0, getDefinables_1.default)(className).size;
exports.default = getDefinablesCount;
